import { APIProvider, Map, AdvancedMarker } from '@vis.gl/react-google-maps';

const TEHRAN = { lat: 35.7219, lng: 51.3347 };
const KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

// Controlled map picker. Click sets the point. value = {lat,lng}|null.
// onClick receives a MapMouseEvent where e.detail.latLng is a plain
// {lat, lng} literal (confirmed via @vis.gl/react-google-maps type defs).
// When readOnly is true the map is DISPLAY-ONLY: clicks are ignored AND all
// gestures are locked (gestureHandling 'none' + keyboard off) so the customer
// cannot pan, zoom, or move the pin. The location was already fixed upstream
// (the feasibility/consult step) and is just being shown back for confirmation.
export default function MapAddressPicker({ value, onChange, height = 280, readOnly = false }) {
  return (
    <div style={{ width: '100%', height, borderRadius: 12, overflow: 'hidden' }}>
      {/* language=fa + region=IR render Google's map labels (street names and
          their numbers) in Persian, matching the rest of the installer UI. */}
      <APIProvider apiKey={KEY} language="fa" region="IR">
        <Map
          defaultCenter={value || TEHRAN}
          defaultZoom={value ? 16 : 12}
          gestureHandling={readOnly ? 'none' : 'greedy'}
          keyboardShortcuts={!readOnly}
          disableDefaultUI
          mapId="installer-picker"
          onClick={readOnly ? undefined : (e) => {
            const ll = e.detail?.latLng;
            if (ll) onChange({ lat: ll.lat, lng: ll.lng });
          }}
        >
          {value && <AdvancedMarker position={value} />}
        </Map>
      </APIProvider>
    </div>
  );
}
